import React, { useState } from "react";
import InputTextMat from "../../../components/common/InputText/InputTextMat";
import Button from "../../../components/common/buttons/Button";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/Routes";
import ItemsIcon from ".//..//..//..//assets//images//icons//items.svg";
import HttpHelper from "../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../constants/API_ROUTES";
import useAuth from "../../../hooks/useAuth";
import { toast } from "react-toastify";

const ZonakAdd = () => {
  const [nev, setNev] = useState("");
  const [nevError, setNevError] = useState("");
  const { getAuth, clearAuth } = useAuth();

  const navigate = useNavigate();

  const validateZone = () => {
    if (nev.length < 1) {
      setNevError("Zóna Nevet kötelező megadni !");
      return false;
    } else {
      setNevError("");
      return true;
    }
  };

  const createZone = () => {
    if (validateZone()) {
      HttpHelper.PostRequest({
        route: API_ROUTES.ZONE_CREATE,
        token: getAuth()?.bearerToken,
        parameters: {
          nev: nev,
        },
      })
        .then((res) => {
          if (res.status === 200) {
            setNev("");
            toast.success("Zóna sikeresen létrehozva !", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else if (res.status === 422) {
            const messages = res.message;
            for (const key in messages) {
              if (messages.hasOwnProperty(key) && Array.isArray(messages[key]) && messages[key].length > 0) {
                const errorMessage = messages[key][0];
                if (key === "nev") {
                  setNevError(errorMessage);
                }
              }
            }
          } else if (res.status === 401) {
            clearAuth();
            navigate(ROUTES.AUTH);
          }
        })
        .catch((error) => {
          toast.error("Unknown error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        });
    }
  };
  return (
    <>
      <div className="px-[1rem]  sm:px-[1.875rem] mt-[3rem]  flex flex-row items-center gap-[1rem] sm:gap-[1.875rem]">
        <Link to={ROUTES.ADMIN_ZONE_LIST}>
          <i className="bg-[rgba(6,85,103,0.5)] h-[4.3rem] w-[4.3rem] rounded-full flex justify-center items-center">
            <img src={ItemsIcon} alt="items icon" className="w-[2.5rem] " />
          </i>
        </Link>

        <h2 className="font-bold font-lato text-[2rem] sm:text-[3.125rem] leading-normal">Zónák</h2>
      </div>

      <div className="flex flex-col gap-12 lg:flex-row">
        {/* Form  - User New User */}
        <div className="lg:order-2 order-1 px-[1rem] sm:px-[1.875rem] overflow-x-auto w-full lg:w-1/2  lg:mt-[7.6rem]">
          <div className="flex flex-col gap-[1.6rem] my-[2.5rem] mb-0">
            <InputTextMat
              label={"Zónák"}
              id={`nev`}
              value={nev}
              name={"nev"}
              error={nevError}
              onChange={(e) => {
                setNev(e.target.value);
              }}
            />
          </div>
          <div className="mt-2 text-end">
            <Button label={`Felhasználó Zónák`} onClick={createZone} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ZonakAdd;
